import { Badge } from '@/components/ui/badge';
import { FC } from 'react';

interface Props {
  className?: string;
}

export const PickupActualBadge: FC<Props> = ({ className = '' }) => (
  <Badge variant="default" className={`bg-slate-900/90 text-white/85 ${className}`}>
    Scheduled Pickup
  </Badge>
);
